import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { type FC, useMemo } from 'react'

import { mountPaginationUrl } from '@/domain/urls'
import { type PaginationProps, Pagination } from '@/ui/molecules/pagination'
import { getBaseUrl } from '@/utils/url'

import { PaginationContainer } from './styled'

export type SrpPaginationProps = Pick<PaginationProps, 'totalPageCount' | 'selectedIndex'>

export const SrpPagination: FC<SrpPaginationProps> = ({ totalPageCount, selectedIndex }) => {
  const { t } = useTranslation('srp')
  const { asPath } = useRouter()

  const generateUrl = useMemo(
    () => (page: number) => {
      let baseUrl = getBaseUrl()

      // Remove last "/" from base URL to prevent redirect url to be mounted as: `kijiji.ca//b-buy-sell...`
      if (baseUrl?.endsWith('/')) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 1)
      }

      const url = `${baseUrl}${asPath}`
      const href = mountPaginationUrl(url, page)

      return { href }
    },
    [asPath]
  )

  return (
    <PaginationContainer>
      <Pagination
        data-testid="srp-pagination"
        generateUrl={generateUrl}
        label={t('pagination.label')}
        nextLabel={t('pagination.next')}
        pageNumberLabel={t('pagination.go_to_page')}
        previousLabel={t('pagination.previous')}
        selectedIndex={selectedIndex}
        totalPageCount={totalPageCount}
      />
    </PaginationContainer>
  )
}
